import MFAStepTwo from './MFAStepTwo'

export default MFAStepTwo
